import { format } from 'date-fns';
import { z } from 'zod';

export const searchSchema = z.object({
  ngay_ct1: z.string().optional(),
  ngay_ct2: z.string().optional(),
  so_ct1: z.string().optional(),
  so_ct2: z.string().optional(),
  dien_giai: z.string().optional(),
  status: z.string().optional(),
  user_id0: z.string().optional()
});

export type SearchFormValues = z.infer<typeof searchSchema>;

export const formSchema = z.object({
  // BasicInfoTab fields
  ma_so_thue: z.string().optional().nullable(),
  ten_kh_thue: z.string().optional().nullable(),
  dia_chi: z.string().optional().nullable(),
  dien_giai: z.string().optional().nullable(),
  ten_vt: z.string().optional().nullable(),
  ghi_chu: z.string().optional().nullable(),
  ong_ba: z.string().optional().nullable(),
  e_mail: z.string().optional().nullable(),
  ma_tt: z.string().optional().nullable(),
  ngay_ct: z.string().optional().nullable(),
  so_ct0: z.string().optional().nullable(),
  so_ct2: z.string().optional().nullable(),
  ngay_ct0: z.string().optional().nullable(),
  ma_nt: z.string().optional().nullable(),
  ty_gia: z.coerce.number().optional().nullable(),
  status: z.string().optional().nullable(),
  transfer_yn: z.boolean().optional().nullable(),

  // EInvoiceTab fields
  ma_tthddt: z.string().optional().nullable(),
  ma_pttt: z.string().optional().nullable(),
  so_ct_hddt: z.string().optional().nullable(),
  ngay_ct_hddt: z.string().optional().nullable(),
  so_ct2_hddt: z.string().optional().nullable(),
  ma_mau_ct_hddt: z.string().optional().nullable(),

  // TaxTab fields
  ma_mau_bc: z.string().optional().nullable(),
  ma_tc_thue: z.string().optional().nullable(),
  ten_vt_thue: z.string().optional().nullable(),
  outvat_yn: z.boolean().optional().nullable(),

  // BottomActionBarV2 fields
  t_so_luong: z.coerce.number().optional().nullable(),
  t_tien_nt: z.coerce.number().optional().nullable(),
  t_tien: z.coerce.number().optional().nullable(),
  t_thue_nt: z.coerce.number().optional().nullable(),
  t_thue: z.coerce.number().optional().nullable(),
  t_tt_nt: z.coerce.number().optional().nullable(),
  t_tt: z.coerce.number().optional().nullable()
});

export type FormSchema = z.infer<typeof formSchema>;

export const initialFormValues: FormSchema = {
  // BasicInfoTab fields
  ma_so_thue: null,
  ten_kh_thue: null,
  dia_chi: null,
  dien_giai: null,
  ten_vt: null,
  ghi_chu: null,
  ong_ba: null,
  e_mail: null,
  ma_tt: null,
  ngay_ct: new Date().toISOString().split('T')[0],
  so_ct0: null,
  so_ct2: null,
  ngay_ct0: new Date().toISOString().split('T')[0],
  ma_nt: null,
  ty_gia: 1.0,
  status: '5',
  transfer_yn: false,

  ma_tthddt: '0',
  ma_pttt: null,
  so_ct_hddt: null,
  ngay_ct_hddt: null,
  so_ct2_hddt: null,
  ma_mau_ct_hddt: null,

  // TaxTab fields
  ma_mau_bc: '3',
  ma_tc_thue: '1',
  ten_vt_thue: null,
  outvat_yn: false,

  // BottomActionBarV2 fields
  t_so_luong: 0,
  t_tien_nt: 0,
  t_tien: 0,
  t_thue_nt: 0,
  t_thue: 0,
  t_tt_nt: 0,
  t_tt: 0
};
